import { setGetPrizeLotteryAction } from '../action';
import { getPrizeLottery } from '../api/getPrizeLottery';

const setGetPrizeLottery = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getPrizeLottery(params);

            if (data.status === 'success') {
                dispatch(setGetPrizeLotteryAction(
                    {
                        prizes: [...data.data]
                    }));
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetPrizeLottery
}